import { TextareaUnstyled } from './unstyled'
import styled from 'styled-components'

export const Textarea = styled(TextareaUnstyled)`
  label {
    display: block;
    padding: 0;
    font-size: ${props => props.theme.fontSizes.form.label};
    color: ${props => props.theme.colors.secondary};
    font-family: ${props => props.theme.fonts.robotoRegular};
    line-height: 24px;
    margin: 0 0 10px 0;
  }

  textarea {
    display: block;
    width: 100%;
    resize: none;
    padding: 16px 20px;
    background: ${props => props.theme.colors.alabaster};
    border: none;
    border-radius: 3px;
    outline: none;

    &::placeholder {
      font-size: ${props => props.theme.fontSizes.form.placeholder};
      color: ${props => props.theme.colors.placeholder};
      letter-spacing: 0.6px;
    }
  }
`
